export default __webpack_public_path__ + "static/summer_containers100-6572b7dc248e7241c54e4fa3ac036804.webp";